export default __webpack_public_path__ + "static/media/inndex-fund-small-midcap-mob.0b1ed74a.jpg";